import React, {Fragment} from 'react';
import _ from "lodash";
import Icon from './Icon';
import Player from "./Player";
import {durationVideo} from "../../libs/helper";

class DisplayImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            refreshImgSrc: this.props.src,
            currentIndex: this.props.currentIndex || 0,
            activeFullScreen: false,
        };
        this.nextThumb = this.nextThumb.bind(this);
        this.prevThumb = this.prevThumb.bind(this);
        this.fullscreen = this.fullscreen.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyPress);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyPress);
    }

    fullscreen() {
        this.setState({activeFullScreen: !this.state.activeFullScreen});
    }

    handleKeyPress({key}) {
        switch (key) {
            case 'ArrowRight':
                this.nextThumb();
                break;
            case 'ArrowLeft':
                this.prevThumb();
                break;
            case 'Escape':
                if (this.state.activeFullScreen) {
                    this.fullscreen();
                } else {
                    this.props.handleClose();
                }
                break;
            default:
        }
    }

    nextThumb() {
        let countThumb = this.props.mediaAttachementArray.length - 1;
        let currentIndex = this.state.currentIndex + 1;
        if (currentIndex > countThumb) {
            currentIndex = 0;
        }
        this.setState({currentIndex})
    }

    prevThumb() {
        let countThumb = this.props.mediaAttachementArray.length - 1;
        let currentIndex = this.state.currentIndex - 1;
        if (currentIndex < 0) {
            currentIndex = countThumb;
        }
        this.setState({currentIndex})
    }

    render() {
        let currentMedia = (this.props.mediaAttachementArray && this.props.mediaAttachementArray[this.state.currentIndex]) || null
            //
        return (
            <div id="displayImage" className={this.state.activeFullScreen ? 'active' : ''}>
                <div className="container column">
                    <div className="main-img-container ">
                        {currentMedia && currentMedia.kind === "video" ? (
                            <Player key={currentMedia._id} media={{...currentMedia, videoCoverUrl : currentMedia.previewUrl}} />
                        ) : null}

                        {currentMedia && currentMedia.kind === "gallery" ? (
                            <img alt={""}
                                 src={currentMedia.previewUrl}/>
                        ) : null}

                    </div>
                    {this.props.mediaAttachementArray.length >= 2 && (
                        <Fragment>
                            <div className="previous" onClick={() => {
                                this.prevThumb()
                            }}><Icon type="chevron-left"/></div>
                            <div className="next" onClick={() => {
                                this.nextThumb()
                            }}><Icon type="chevron-right"/></div>
                        </Fragment>
                    )}

                    <div className="fullscreen" onClick={this.fullscreen}>
                        {!this.state.activeFullScreen ? (
                            <Icon type="arrows-alt"/>
                        ) : (
                            <Icon type="compress"/>
                        )}
                    </div>
                    <div className="all-images row">
                        {this.props.mediaAttachementArray.length >= 2 && this.props.mediaAttachementArray.map((item, index) => (
                            <div
                                key={index}
                                className={`img-container ${this.state.currentIndex === index ? 'active' : ''}`}
                                style={{backgroundImage: `url(${item.previewUrl})`}}
                                onClick={() => this.setState({currentIndex: index})}
                            >
                                {item.kind === "video" ? (<div className={"duration"}><Icon type="play"/> {durationVideo(_.get(item, "file.duration") || 0)}</div>) : null}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }
}

export default DisplayImage;
